// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2OEWO","savePackageButton":"ClientWallet_savePackageButton__EYQUo"};